// main.js
// ------------------------------
// Vue 3 应用入口文件
// ------------------------------

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// -------- 引入第三方UI组件库 --------
import ElementPlus from 'element-plus';            // Element Plus UI
import 'element-plus/theme-chalk/index.css';      // Element Plus 样式

import Antd from 'ant-design-vue';  // 表格渲染用的
import 'ant-design-vue/dist/antd.css';

import draggable from "vuedraggable";


// // ① 先加载 xe-utils（vxe-table 的硬依赖，必须在前）
// import 'xe-utils'
//
// // ② 引入样式（不引也能跑，但没样式）
// import 'vxe-table/lib/style.css'
//
// // ③ 全量注册 vxe-table（会注册 vxe-table / vxe-column / vxe-pager 等）
// import VXETable from 'vxe-table'





// -------- 网络请求相关 --------
import './axios-interceptor';                     // axios 拦截器配置

// -------- 图片懒加载 --------
import VueLazyload from 'vue-lazyload';

// -------- 网站图标 --------
const nyIcon = 'https://static.nuanyu.site/assets/photos/暖_宝绿色底.jpg';

// -------- 创建 Vue 应用实例 --------
const app = createApp(App);

// -------- 使用插件 --------
// ElementPlus
app.use(ElementPlus);
// app.use(VXETable)



// 全量注册 Ant Design Vue 组件
app.use(Antd);

// Vue Router
app.use(router);

// VueLazyload 配置
app.use(VueLazyload, {
    preLoad: 1.3,                                // 预加载比例，提前加载距离屏幕1.3倍的图片
    error: require('./assets/icon/error.png'),   // 加载失败显示的图片
    loading: require('./assets/gif/loading_2.gif'), // 加载中显示的占位图
    attempt: 1                                   // 尝试加载次数
});

// -------- 动态设置 favicon --------
const link = document.createElement('link');     // 创建 <link> 元素
link.rel = 'icon';                               // 设置为网站图标
link.href = nyIcon;                              // 指定图标路径
document.head.appendChild(link);                 // 添加到 <head> 中

// -------- 挂载 Vue 应用 --------
app.mount('#app');
